
import Vue from 'vue';
import utils from './utils'
import vsNotifications from './index.vue'

const NotiConstructor = Vue.extend(vsNotifications);


let instance;

export default function vsfunction(parameters, that) {
    if (parameters.fullWidth) {
        if (parameters.position) {
            parameters.position = parameters.position.replace('right', 'left')
        }
    }
    instance = new NotiConstructor({
        data: parameters,
    });
    instance.vm = instance.$mount();
    parameters.click ? instance.vm.$on('click', parameters.click) : null
    let bodyEl = that ? that.$el : null // кастомная проверка  ( Если передан this то создаю уведомление в нем , во всех остальных случаях в body)
    utils.insertBody(instance.vm.$el, bodyEl);
}
